import AddressModal from '../../Components/AddressModal/AddressModal';
import EventModal from '../../Components/events/event-modal/EventModal';
import FranchiseModal from '../../Components/fare/franchise-modal/FranchiseModal';

import { DeliveryModal } from '../delivery-modal/delivery-modal';
import { useAppSelector } from '../../_store/hooks';
import { selectEventModalData } from '@/_store/modules/layout/selectors';

function GlobalModals() {
  const isFareModalVisible = useAppSelector(
    state => state.franchises.isFareModalVisible,
  );

  const openedAddressModal = useAppSelector(
    state => state.layout.openedAddressModal,
  );

  const openedEventModal = useAppSelector(selectEventModalData);

  return (
    <>
      <DeliveryModal />
      {isFareModalVisible ? <FranchiseModal /> : null}
      {openedAddressModal ? <AddressModal /> : null}
      {openedEventModal ? <EventModal /> : null}
    </>
  );
}

export default GlobalModals;
